module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bed-a52078d3b8d63d8b87975ae6311d60cc.svg";